import React from "react";

import type { OrgMember } from "../API";
import { fmtWhen, initials } from "./format";
import type { SettingsPageProps } from "./OrgActions";

const MemberRow: React.FC<
  {
    member: OrgMember;
    seated: boolean;
    onToggleSeat: () => void;
  } & Pick<SettingsPageProps, "busy" | "run" | "actions">
> = ({ member, seated, onToggleSeat, busy, run, actions }) => (
  <div className="dg-user-row">
    <div className="dg-av">{initials(member.name, member.email)}</div>
    <div className="dg-user-info">
      <div className="dg-user-name">{member.name || member.email}</div>
      <div className="dg-user-meta">
        {member.email}
        {!member.has_seat &&
          (member.signed_in === false ? " · Never signed in" : " · No seat")}
      </div>
      {/* Who isn't using Dooglie, for the admin to coach. Absent from a
          backend that predates it, so nothing is claimed then. */}
      {member.signed_in !== false && member.last_active_at !== undefined && (
        <div className="dg-user-meta">
          {member.last_active_at ? `Active ${fmtWhen(member.last_active_at)}` : "Not seen yet"}
          {" · "}
          {member.last_call_at ? `Last call ${fmtWhen(member.last_call_at)}` : "No calls yet"}
        </div>
      )}
    </div>
    <label className="dg-check">
      Seat
      <input type="checkbox" checked={seated} disabled={busy} onChange={onToggleSeat} />
    </label>
    <label className="dg-check">
      Admin
      <input
        type="checkbox"
        checked={member.is_admin}
        disabled={busy}
        onChange={(e) =>
          run(() => actions.setAdmin(member.email, e.target.checked))
        }
      />
    </label>
  </div>
);

export default MemberRow;
